import { useEffect, useState } from "react";
import { fetchGroupList, respondGroupPurchase } from "./rewardAPI";
import { announceBalance, formatPoint } from "./pointStore";
import { CoinIcon, FriendsBadge } from "./RewardIcons";
import "./Store.css";

// 친구가 '같이 사기' 에 나를 넣었으면 학생 화면을 열 때 물어본다(2026-10-04).
// 대답을 기다리는 것만 하나씩 띄운다. 모두 '좋아요' 해야 쿠폰을 산다.
const GroupInvitePopup = () => {
  const [inviteList, setInviteList] = useState([]);
  const [message, setMessage] = useState("");
  const [isBusy, setIsBusy] = useState(false);

  useEffect(() => {
    fetchGroupList()
      .then((data) =>
        setInviteList(data.group_list.filter((group) => group.status === "waiting" && group.my_status === "invited"))
      )
      .catch(() => {});
  }, []);

  const invite = inviteList[0];
  if (!invite) return null;

  const answer = async (isAgreed) => {
    setIsBusy(true);
    setMessage("");
    try {
      const data = await respondGroupPurchase(invite.id, isAgreed);
      announceBalance(data.balance);
      if (isAgreed && data.group.status === "completed") alert("모두 모였어요! 쿠폰함에서 볼 수 있어요.");
      setInviteList(inviteList.slice(1));
    } catch (error) {
      setMessage(error.message);
    }
    setIsBusy(false);
  };

  return (
    <div className="store-sheet">
      <div className="store-sheet__body">
        <div className="store-invite__badge">
          <FriendsBadge />
        </div>
        <div className="store-sheet__title store-invite__title">
          <b>{invite.starter_name}</b> 친구가 같이 사자고 해요
        </div>
        <div className="store-invite__product">
          {invite.product.goods_name.startsWith(invite.product.brand_name)
            ? invite.product.goods_name
            : `${invite.product.brand_name} ${invite.product.goods_name}`}
        </div>
        <div className="store-split">
          {invite.member_list.map((member) => (
            <div className="store-split__row" key={member.name}>
              <span>{member.name}</span>
              <b>{formatPoint(member.share_points)}</b>
            </div>
          ))}
        </div>
        <div className="store-price">
          <CoinIcon size="0.9em" /> 내 몫 {formatPoint(invite.my_share)}
        </div>
        {message && <div className="store-message">{message}</div>}
        <button type="button" className="store-button" onClick={() => answer(true)} disabled={isBusy}>
          같이 살래요
        </button>
        <button type="button" className="store-button store-button--ghost" onClick={() => answer(false)} disabled={isBusy}>
          안 할래요
        </button>
      </div>
    </div>
  );
};

export default GroupInvitePopup;
